
  let subModalIntervalCounter = 0
  const initCustomRechargeModal = setInterval(()=>{
    subModalIntervalCounter++
    const rechargeEl = document.querySelector('.rc_popup__hover')

      if(subModalIntervalCounter > 10 ){
          clearInterval(initCustomRechargeModal)
      }

      if(!!rechargeEl){
          clearInterval(initCustomRechargeModal)
            customizeRechargePopUp()
      }

  },500)


  function customizeRechargePopUp(){
    const htmlEl = document.querySelector('html')
    const bodyEl = document.querySelector('body')
    const customPopUpHover = document.querySelector('.custom-pop-up__hover-icon-container')
    const customClose = document.querySelector('.custom-pop-up__close')
    const customPopUp = document.querySelector('.custom-pop-up__hover-container')
    const subOverlay = document.querySelector('.custom-pop-up__mobile-overlay')
    showHoverElement()
    
    
    customPopUpHover.addEventListener('mouseenter', ()=>{
        if(window.innerWidth > 768 ){
            showCustomModal()
        }
    })

    customPopUpHover.addEventListener('mouseleave', ()=>{
        if(window.innerWidth > 768 ){
            hideCustomModal()
        }
    })

    subOverlay.addEventListener('click', (event)=>{
            hideCustomModal()
            event.stopPropagation()
    })

    customPopUpHover.addEventListener('click', ()=>{
        showCustomModal()
    })

    customClose.addEventListener('click',(event)=>{
        hideCustomModal()
        event.stopPropagation()
    })

    function hideCustomModal(){
        customPopUp.style.opacity = '0'
        customPopUp.style.zIndex = '-2'
        subOverlay.style.display = 'none'
        htmlEl.classList.remove('product-modal-overflow-hidden')
        bodyEl.classList.remove('product-modal-overflow-hidden')
    }

    function showCustomModal(){
        customPopUp.style.opacity = '1'
        customPopUp.style.zIndex = '999999'
        subOverlay.style.display = 'flex'
        htmlEl.classList.add('product-modal-overflow-hidden')
        bodyEl.classList.add('product-modal-overflow-hidden')
    }

    function showHoverElement(){
        customPopUpHover.style.display = 'flex'
    }


}